import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Copy, ArrowLeft, ClipboardList } from 'lucide-react';
import TicketSupport from '@/components/TicketSupport';
import TicketTracker from '@/components/TicketTracker';
import { useLang } from '@/context/LanguageContext';

export default function TicketPage() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [view, setView] = useState('submit'); // submit | track

  const shareUrl = typeof window !== 'undefined' ? `${window.location.origin}/ticket` : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success(lang === 'en' ? 'Link copied!' : 'Link disalin!');
    } catch {
      toast.error(lang === 'en' ? 'Copy failed' : 'Gagal menyalin');
    }
  };

  return (
    <div className="min-h-screen t-bg" data-testid="ticket-page">
      {/* Header */}
      <header className="sticky top-0 z-30 border-b glass" style={{ borderColor: 'var(--border-color)' }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-2">
          <button
            onClick={() => navigate('/')}
            data-testid="ticket-page-back"
            className="inline-flex items-center gap-1.5 text-sm t-text-secondary hover:text-[#D98A94]"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">{lang === 'en' ? 'Home' : 'Beranda'}</span>
          </button>
          <div className="text-xs sm:text-sm font-semibold t-text tracking-wide">
            {lang === 'en' ? 'Ticket System' : 'Sistem Tiketing'}
          </div>
          <button
            onClick={copyLink}
            data-testid="ticket-page-copy"
            className="inline-flex items-center gap-1.5 text-xs bg-[#D98A94] hover:bg-[#D98A94]/90 text-white rounded-full px-3 py-1.5"
          >
            <Copy className="w-3 h-3" />
            <span className="hidden sm:inline">{lang === 'en' ? 'Copy Link' : 'Salin Link'}</span>
          </button>
        </div>
      </header>

      {/* Sub-nav: submit vs track */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-6">
        <div className="glass-card rounded-full p-1 flex gap-1">
          <button
            onClick={() => setView('submit')}
            data-testid="ticket-page-tab-submit"
            className={`flex-1 py-2 rounded-full text-sm font-semibold ${view === 'submit' ? 'bg-[#D98A94] text-white' : 't-text-secondary'}`}
          >
            {lang === 'en' ? 'Submit Ticket' : 'Buat Tiket'}
          </button>
          <button
            onClick={() => setView('track')}
            data-testid="ticket-page-tab-track"
            className={`flex-1 py-2 rounded-full text-sm font-semibold inline-flex items-center justify-center gap-1.5 ${view === 'track' ? 'bg-[#D98A94] text-white' : 't-text-secondary'}`}
          >
            <ClipboardList className="w-3.5 h-3.5" />
            {lang === 'en' ? 'Track Ticket' : 'Cek Tiket'}
          </button>
        </div>
      </div>

      {view === 'submit' ? <TicketSupport /> : <TicketTracker />}
    </div>
  );
}
